module.exports = __webpack_public_path__ + "img/test.1d85bcca.png";